(function () {
  function initMarquee(section) {
    var wall = section.querySelector('.community-wall') || section;
    var wrap = section.querySelector('[data-cw-wrap]');
    var track = section.querySelector('[data-cw-track]');
    var originalSet = section.querySelector('[data-cw-set]');
    if (!wrap || !track || !originalSet) {
      console.warn('[Community Wall] Marquee elements not found — check that the section markup matches section-community-wall.js expectations.');
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var direction = wall.getAttribute('data-scroll-direction') === 'right' ? 1 : -1;
    var pauseOnHover = wall.getAttribute('data-pause-on-hover') === 'true';
    var durationSeconds = parseFloat(getComputedStyle(wall).getPropertyValue('--cw-scroll-duration')) || 40;

    var setWidth = 0;
    var speed = 0; // px per ms
    var offset = 0;
    var isPaused = false;
    var rafId = null;
    var lastTimestamp = null;

    function clearClones() {
      var clones = track.querySelectorAll('[data-cw-set-clone]');
      clones.forEach(function (clone) { clone.remove(); });
    }

    function buildTrack() {
      clearClones();
      setWidth = originalSet.getBoundingClientRect().width;
      if (setWidth <= 0) return;

      var wrapWidth = wrap.getBoundingClientRect().width;
      var needed = Math.ceil((wrapWidth * 2) / setWidth) + 1;

      for (var i = 0; i < needed; i++) {
        var clone = originalSet.cloneNode(true);
        clone.setAttribute('data-cw-set-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        var gap = parseFloat(getComputedStyle(originalSet).gap) || 0;
        clone.style.marginLeft = gap + 'px';
        track.appendChild(clone);
      }

      speed = setWidth / (durationSeconds * 1000); // px per ms, constant regardless of clone count
      offset = direction === -1 ? 0 : -setWidth;
      track.style.transform = 'translateX(' + offset + 'px)';
    }

    function step(timestamp) {
      if (lastTimestamp === null) lastTimestamp = timestamp;
      var delta = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      if (!isPaused && setWidth > 0) {
        offset += direction * speed * delta;

        if (direction === -1 && offset <= -setWidth) {
          offset += setWidth;
        } else if (direction === 1 && offset >= 0) {
          offset -= setWidth;
        }

        track.style.transform = 'translateX(' + offset + 'px)';
      }

      rafId = window.requestAnimationFrame(step);
    }

    if (pauseOnHover) {
      wrap.addEventListener('mouseenter', function () { isPaused = true; });
      wrap.addEventListener('mouseleave', function () { isPaused = false; });
      wrap.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
      wrap.addEventListener('touchend', function () { isPaused = false; }, { passive: true });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        lastTimestamp = null;
        buildTrack();
      }, 200);
    });

    buildTrack();
    rafId = window.requestAnimationFrame(step);
  }

  function initAll() {
    document.querySelectorAll('.section-community-wall').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-community-wall');
    if (section) initMarquee(section);
  });
})();